// Intern OS configuration
// Single configurable string — change here without code surgery.
export const PRODUCT_NAME = import.meta.env.VITE_INTERN_PRODUCT_NAME || 'Intern OS';

// Escalation thresholds (days before due_date → orange; on/after → red)
export const ESCALATION_ORANGE_DAYS = 2;

// Timezone used for "today" computation
export const APP_TIMEZONE = 'America/Denver';
